(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moveu-programs-menu"] && !Shopify.designMode) return;
  try {
    if (!window.moveuProgramsMenuBound) {
  window.moveuProgramsMenuBound = true;
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const details = event.target.closest('.moveu-programs-disclosure[open]');
    if (!details) return;
    details.removeAttribute('open');
    details.querySelector('summary').focus();
  });
  document.addEventListener('pointerdown', (event) => {
    document.querySelectorAll('.moveu-programs-disclosure[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });
}
  } catch(e) { console.error(e); }
})();

})();
